module.exports = __webpack_public_path__ + "img/xby.aaf31e0f.png";